export type InstallAttempt = 'idle' | 'accepted-pending' | 'dismissed' | 'unavailable' | 'error';
type Offer = {prompt():Promise<void>;userChoice?:Promise<{outcome:string}>};
export async function consumeInstallOffer(win:{__whhInstall?:Offer}):Promise<InstallAttempt> {
 const offer=win.__whhInstall;
 if(!offer)return 'unavailable';
 // Browser offers are one-shot. Remove before awaiting, including rejection.
 win.__whhInstall=undefined;
 try {await offer.prompt();return (await offer.userChoice)?.outcome==='dismissed'?'dismissed':'accepted-pending';}
 catch {return 'error';}
}
export function installationStatus(standalone:boolean,confirmed:boolean,attempt:InstallAttempt) {
 return standalone?'standalone':confirmed?'confirmed':attempt==='accepted-pending'?'pending':'guidance';
}
export async function installForRoute(win:Parameters<typeof consumeInstallOffer>[0],isCurrent:()=>boolean,update:(result:InstallAttempt)=>void) {
 const result=await consumeInstallOffer(win);
 if(isCurrent())update(result);
}
